"use strict";

angular.module('app.mainErrorService', [])
    .factory('mainError', [
        function () {
            return {
                set: function (message, type) {

                },
                clear: function () {

                }
            };
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/fhApp/mainErrorService.js